/*
 * @Author: chenxing
 * @Date: 2021-05-13 10:01:57
 * @LastEditors: chenxing
 * @LastEditTime: 2021-05-14 17:52:05
 */
// canvas 实现 watermark
const canvasMask = {
    observe: null,
    defaultSetting: {
        container: document.body,
        width: '130px',
        height: '100px',
        textAlign: 'center',
        textBaseline: 'middle',
        font: '15px Microsoft Yahei',
        fillStyle: 'rgba(184, 184, 184, 0.2)',
        content: '请勿外传',
        rotate: '30',
        zIndex: 1000,
    },
    createMask: function () {
        const args = arguments[0];
        let settings = { ...this.defaultSetting, ...args };
        const canvas = document.createElement('canvas');

        canvas.setAttribute('width', settings.width);
        canvas.setAttribute('height', settings.height);
        const ctx = canvas.getContext('2d');

        ctx.textAlign = settings.textAlign;
        ctx.textBaseline = settings.textBaseline;
        ctx.font = settings.font;
        ctx.fillStyle = settings.fillStyle;
        ctx.rotate(Math.PI / 180 * settings.rotate);
        ctx.fillText(settings.content, parseFloat(settings.width) / 2, parseFloat(settings.height) / 2);

        const base64Url = canvas.toDataURL();
        const __wm = document.querySelector('.__wm');

        const watermarkDiv = __wm || document.createElement('div');
        const styleStr = `
          position:absolute;
          top:0;
          left:0;
          width:100%;
          height:100%;
          z-index:${settings.zIndex};
          pointer-events:none;
          background-repeat:repeat;
          background-image:url('${base64Url}')`;

        watermarkDiv.setAttribute('style', styleStr);
        watermarkDiv.className = ('__wm');
        // watermarkDiv.classList.add('__wm');

        if (!__wm) {
            settings.container.style.position = 'relative';
            settings.container.insertBefore(watermarkDiv, settings.container.firstChild);
        }

        const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
        if (MutationObserver) {
            let _this = this;
            _this.observe = new MutationObserver(function () {
                const __wm = document.querySelector('.__wm');
                // 只在__wm元素变动才重新调用 _createMask
                if ((__wm && __wm.getAttribute('style') !== styleStr) || (__wm && __wm.className !== '__wm') || !__wm) {
                    // 避免一直触发
                    if (_this.observe) {
                        _this.observe.disconnect();
                        _this.observe = null;
                    }
                    _this.createMask({ ...args });
                }
            });

            _this.observe.observe(settings.container, {
                attributes: true,
                subtree: true,
                childList: true
            });
        }

    },
    deleteMask: function () {
        if (this.observe) {
            this.observe.disconnect();
            this.observe = null;
        }

        let ele = document.querySelector('.__wm');
        ele && ele.remove();
    }
};

export default canvasMask;